/**
 * Where a study's reports are read from: the study itself (signed-in users)
 * or a share link (anonymous / patient viewer).
 */
type ReportsSource =
  | { kind: 'study'; studyInstanceUid: string }
  | { kind: 'shared'; studyHash: string };

/** API path prefix of the source's reports. */
export const reportsBasePath = (source: ReportsSource): string =>
  source.kind === 'study'
    ? `/studies/${source.studyInstanceUid}/reports`
    : `/studies/shared/${source.studyHash}/reports`;

/** Identifies the source in query keys; empty while it is unknown. */
export const reportsSourceId = (source: ReportsSource): string =>
  source.kind === 'study'
    ? source.studyInstanceUid
    : source.studyHash && `shared:${source.studyHash}`;

export default ReportsSource;
